/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxRows: NonNullable<unknown>, maxSize: NonNullable<unknown> }} Datasets_Import_Csv_HintInputs */



/**
* | output |
* | --- |
* | "Up to {maxRows} rows and {maxSize}. The first row must be the header." |
*
* @param {Datasets_Import_Csv_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_import_csv_hint = /** @type {((inputs: Datasets_Import_Csv_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Import_Csv_HintInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Bis zu ${i?.maxRows} Zeilen und ${i?.maxSize}. Die erste Zeile muss die Kopfzeile sein.`)
	return /** @type {LocalizedString} */ (`Up to ${i?.maxRows} rows and ${i?.maxSize}. The first row must be the header.`)
});